// extracted by css-extract-rspack-plugin
export default {"notice":"RelatedRecordsAlert__notice--p59PB","actionButton":"RelatedRecordsAlert__actionButton--Nt7Mh"};